import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

type DiagnoseOverviewRemarkMutationPayload = {
  diagnose_overview_remark_id: number;
  handled_remark: boolean; // TODO: ask backend to be consistent and name this handled
};

export const useDiagnoseOverviewRemarkMutation = () =>
  useTypedMutation<DiagnoseOverviewRemarkMutationPayload, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/diagnose_overview/remark/handle", payload);
    },
    onSuccess: ({ diagnose_overview_remark_id, handled_remark }) => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.customer_communication?.diagnose_overview_remarks?.length) return;

      const diagnoseRemarkIdx = appointment.customer_communication.diagnose_overview_remarks.findIndex(remark => remark.id === diagnose_overview_remark_id);
      if (diagnoseRemarkIdx < 0) return;

      const customer_communication = {
        ...appointment.customer_communication,
        diagnose_overview_remarks: appointment.customer_communication.diagnose_overview_remarks.with(diagnoseRemarkIdx, {
          ...appointment.customer_communication.diagnose_overview_remarks[diagnoseRemarkIdx],
          receptionist_handled: handled_remark
        })
      };

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, { ...appointment, customer_communication });
    }
  });
